import React, { useContext, useEffect, useState } from 'react';
import BlockUi from 'react-block-ui';
import { Loader } from 'react-loaders';
import { PaymentInputsWrapper, usePaymentInputs } from 'react-payment-inputs';
import images from 'react-payment-inputs/images';
import { NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Card, CardBody, Input } from 'reactstrap';
import styled from "styled-components";
import swal from 'sweetalert';
import validator from 'validator';
import courseIcon from '../../assets/icon-primeira-fase.png';
import CustomCheckBox from '../../components/CustomCheckBox';
import { AuthContext } from '../../contexts/AuthContext';
import decimal from '../../helpers/decimal';
import paymentTypeEnum from '../../helpers/enums/paymentType';
import utils from '../../helpers/utils';
import api from "../../services/api";


const Container = styled.div`
background-color: rgba(41, 107, 169, 1);
height: 100%;
width: 100%;
overflow: hidden;
padding: 50px;
@media (max-width: 768px) {
    padding: 10px;
    overflow: scroll;
  }
`;

const CardTitle = styled.h5`
  font-weight: bold;
  text-transform: uppercase;
  color: rgb(57, 118, 170);
  font-size: 25px;
  @media (max-width: 768px) {
    margin-top: 5px;
  }
`

const RegisterCard = styled(Card)`
  height: 100%;
  width: 100%;
`;

const RegisterBody = styled(CardBody)`
  overflow: auto;
`

const FormWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  @media (max-width: 768px) {
    flex-direction: column;
    overflow: auto;
  }
`

const RegisterForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
  @media (min-width: 768px) {
    border-right: 1px solid #ccc;
  }
`

const CreditCardForm = styled.div`
  width: 100%;
  border-left: 1px solid #ccc;
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
  @media (min-width: 768px) {
    overflow: scroll;
    height: 450px;
  }
`

const ErrorSpan = styled.span`
    color: #c9444d;
    font-size: 0.75rem;
    margin-top: 0.25rem;
`

const FooterCard = styled.div`
    display: flex;
    margin-top: 10px;
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
    }
    @media (min-width: 768px) {
      margin-left: auto;
      margin-right: 15px;
  }
      margin-bottom: 15px;
`

const StyledButtonLink = styled(NavLink)`
  color: #fff;
  background-color:  #5cb85b;
  border-radius: 20px;
  padding: 5px 10px;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: bold;
  width: 220px;
  text-align: center;
  @media (max-width: 768px) {
    width: 95%;
    margin-bottom: 10px;
  }
  @media (min-width: 768px) {
    margin-right: 5px;
  }
  &:hover {
    text-decoration: none;
    color: #ddd;
    background-color: #376e37; 
  }
  &:active {
    font-weight: bold;
  }
`;

const StyledButton = styled.div`
  cursor: pointer;
  color: #fff;
  background-color:  rgba(35, 157, 219, 1);
  border-radius: 20px;
  padding: 5px 10px;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: bold;
  width: 220px;
  text-align: center;
  @media (max-width: 768px) {
    width: 95%;
  }
  &:hover {
    text-decoration: none;
    color: #ddd;
    background-color: rgba(41, 107, 169, 1); 
  }
  &:active {
    font-weight: bold;
  }
`;


const CourseContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 5px;
  align-items: center;
`

const CourseTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 5px;
`

function BuyCourse(props) {
  const { dispatch } = useContext(AuthContext)
  const [course, setCourse] = useState('')
  const [name, setName] = useState("")
  const [lastname, setLastname] = useState("")
  const [email, setEmail] = useState("")
  const [document, setDocument] = useState("")
  const [password, setPassword] = useState("")
  const [passwordConfirmation, setPasswordConfirmation] = useState("")
  const [terms, setTerms] = useState(false)
  const [paymentName, setPaymentName] = useState("");
  const [paymentDocument, setPaymentDocument] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [cvc, setCVC] = useState("");
  const [installments, setInstallments] = useState(1)
  const [priceWithInstallments, setPriceWithInstallments] = useState([])
  const [priceWithInstallmentsDefault, setPriceWithInstallmentsDefault] = useState([])
  const [promotionCode, setPromotionCode] = useState("")
  const [errors, setErrors] = useState({})
  const [loading, setLoading] = useState(false)

  const handleInstallmentsLength = id => {
    if(id === '6707e626fd296106f1170ce0') return [1, 2, 3 ,4];
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    // if(id === '62c2f90f5bc4416696d1444d' || id === '63348022849af5728c2839a0') return [1, 2, 3, 4]
    // else return [1, 3, 6, 9, 12]
  }

  const settedInstallments = handleInstallmentsLength(props.match.params.id)

  useEffect(() => {
    const { id } = props.match.params
    if (!id)
      props.history.push('/')
    else {
      setLoading(true)
      api.get(`/course/${id}`).then(res => {
        setCourse(res.course)
        let newPriceWithInstallments = []
        for (let index = 0; index < settedInstallments.length; index++) {
          let coursePrice = res.course.price
          let price = decimal.div(coursePrice, settedInstallments[index])
          newPriceWithInstallments.push(price)
        }
        setPriceWithInstallments(newPriceWithInstallments)
        setPriceWithInstallmentsDefault(newPriceWithInstallments)
        setLoading(false)
      }).catch(error => {
        props.history.push('/')
      })
    }
  }, [])

  useEffect(() => {
    if (promotionCode === REACT_APP_PROMOTIONCODE) {
      let newPriceWithInstallments = []
      for (let index = 0; index < settedInstallments.length; index++) {
        let coursePrice = decimal.sub(course.price, decimal.div(decimal.mul(course.price, REACT_APP_PROMOTIONDISCOUNT), 100))
        let price = decimal.div(coursePrice, settedInstallments[index])
        newPriceWithInstallments.push(price)
      }
      setPriceWithInstallments(newPriceWithInstallments)
    } else {
      setPriceWithInstallments(priceWithInstallmentsDefault)
    }
  }, [promotionCode])

  const ERROR_MESSAGES = {
    emptyCardNumber: 'O número do cartão não pode estar vazio.',
    invalidCardNumber: 'O número do cartão é inválido.',
    emptyExpiryDate: 'A data de expiração não pode estar vazia.',
    monthOutOfRange: 'O mês de expiração deve estar entre 01 e 12.',
    yearOutOfRange: 'O ano de expiração não pode estar no passado.',
    dateOutOfRange: 'A data de expiração não pode estar no passado.',
    invalidExpiryDate: 'A data de expiração é inválida.',
    emptyCVC: 'O código de segurança não pode estar vazio.',
    invalidCVC: 'O código de segurança é inválido.'
  }

  const {
    meta,
    wrapperProps,
    getCardImageProps,
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps
  } = usePaymentInputs({ errorMessages: ERROR_MESSAGES });
  const link = <>Eu li e concordo com os <a href={`${process.env.REACT_APP_HOST}/static/termos_de_uso.pdf`} target="_blank" rel="noopener noreferrer">termos de uso</a> da plataforma</>

  const submitForm = () => {
    let isValid = true;
    let error = {}
    if (!name) {
      error.name = "O campo nome é obrigatório"
      isValid = false;
    } else if (name.length > 70) {
      error.name = "O campo nome possui mais que 70 caractéres"
      isValid = false;
    }
    if (!lastname) {
      error.lastname = "O campo sobrenome é obrigatório"
      isValid = false;
    } else if (lastname.length > 70) {
      error.lastname = "O campo sobrenome possui mais que 70 caractéres"
      isValid = false;
    }
    if (!password) {
      error.password = "O campo senha é obrigatório"
      isValid = false;
    } else if (password.length < 6) {
      error.password = "A senha não contém no mínimo 6 caracteres"
      isValid = false;
    } else if (password !== passwordConfirmation) {
      error.password = "As senhas não são iguais"
      isValid = false
    }
    if (!passwordConfirmation) {
      error.passwordConfirmation = "O campo confirmação de senha é obrigatório"
      isValid = false
    } else if (passwordConfirmation !== password) {
      error.passwordConfirmation = "As senhas não são iguais"
      isValid = false
    }
    if (!email) {
      error.email = "O campo email é obrigatório"
      isValid = false
    } else if (!validator.isEmail(email)) {
      error.mail = "O campo email esta no formato incorreto"
      isValid = false
    }
    if (!document) {
      error.document = "O campo documento é obrigatório"
      isValid = false
    }
    if (!terms) {
      error.terms = "É nescessário aceitar os termos"
      isValid = false
    }
    if (!paymentName) {
      error.paymentName = "O campo nome do pagamento é obrigatório"
      isValid = false;
    } else if (name.length > 70) {
      error.paymentName = "O campo nome do pagamento possui mais que 70 caractéres"
      isValid = false;
    }
    if (!paymentDocument) {
      error.paymentDocument = "O campo documento do pagamento é obrigatório"
      isValid = false
    }

    if (!cardNumber) {
      toast.error('Informe o número do cartão')
      isValid = false
    }
    setErrors(error)
    if (isValid && !meta.error) {
      setLoading(true)
      const hasPromotion = promotionCode === REACT_APP_PROMOTIONCODE
      let priceCourse = course.price
      if (hasPromotion) priceCourse = decimal.sub(course.price, decimal.div(decimal.mul(course.price, REACT_APP_PROMOTIONDISCOUNT), 100))
      priceCourse = decimal.div(priceCourse, installments)
      swal({
        title: "Compra de curso",
        text: `Você confirma a compra de ${course.name} no valor de ${utils.formatBRL(priceCourse)} em ${installments}x`,
        icon: "warning",
        buttons: {
          cancel: "Voltar",
          confirm: "Sim"
        },
        dangerMode: true,
      }).then((willBuy) => {
        if (willBuy) {
          let payload = {
            user: {
              name,
              lastname,
              document,
              email,
              password,
              passwordConfirmation
            },
            type: paymentTypeEnum.CREDIT_CARD,
            courseId: course._id,
            promotionCode: !promotionCode ? undefined : promotionCode,
            customer: {
              name: paymentName,
              document: paymentDocument
            },
            payment: {
              amount: course.price,
              softDescriptor: `GrupoMPT`,
              installments
            },
            creditCard: {
              number: cardNumber.replaceAll(" ", ""),
              holder: paymentName,
              expirationDate: expiryDate.replaceAll(" ", "").replace("/", "/20"),
              securityCode: cvc,
              brand: meta.cardType.type === "mastercard" ? "Master" : meta.cardType.type
            }
          }
          const link = "/student/createAndCreditCardEnrollment"
          api.post(link, { ...payload }).then(res => {
            if (res.success) {
              setLoading(false)
              toast.success("Compra e registro efetuado com sucesso!");
              props.history.push("/")
            } else {
              if (Array.isArray(res.error)) {
                let error = ''
                res.error.forEach(e => {
                  error += `O campo ${e.path[0]} está com valores inválidos.\n`
                })
                setErrors({ serverSide: error })
                setLoading(false)
                toast.error("Ops, algo deu errado!");
              } else {
                setErrors({ serverSide: res.error })
                setLoading(false)
                toast.error("Ops, algo deu errado!");
              }
            }
          }).catch(err => {
            setLoading(false)
            if (error.response.data.message == 'Not Authorized') {toast.error('Transação não autorizada.')}
            else if (error.response.data.message == 'Blocked Card') {toast.error('Cartão de crédito bloqueado.')}
            else if (error.response.data.message == 'Timeout ') {toast.error('Limite de tempo de transação excedido.')}
            else if (error.response.data.message == 'Problems with Creditcard') {toast.error('Há um problema com o cartão de crédito.')}
            else if (error.response.data.message == 'Card Canceled') {toast.error('Cartão de crédito cancelado.')}
            else if (error.response.data.message == 'Card Expired') {toast.error('Cartão de crédito expirado.')} 
            else {toast.error('Ops, algo deu errado!')}

            console.log(err)
          })
        } else {
          setLoading(false)
          return true;
        }
      })
    } else {
      setLoading(false)
    }
  }
  const { REACT_APP_PROMOTIONCODE, REACT_APP_PROMOTIONDISCOUNT } = process.env
  return <Container>
    <BlockUi tag="div" blocking={loading} loader={<Loader active type="line-scale-party" color="#296ba9" />} >
      <RegisterCard>
        <FormWrapper>
          <RegisterForm>
            <CardTitle>Dados de Cadastro</CardTitle>
            <Input
              name="name"
              placeholder="Nome"
              maxLength={70}
              error={errors ? errors.name : ''}
              value={name}
              onChange={event => setName(event.target.value)}
              className="form-control"
              style={{
                border: errors.name ? '2px solid #c9444d' : '1px solid #ced4da', marginBottom: '2px'
              }}
            />
            <ErrorSpan>{errors.name}</ErrorSpan>
            <Input
              name="lastname"
              placeholder="Sobrenome"
              maxLength={70}
              error={errors ? errors.lastname : ''}
              value={lastname}
              onChange={event => setLastname(event.target.value)}
              className="form-control"
              style={{
                border: errors.lastname ? '2px solid #c9444d' : '1px solid #ced4da', marginBottom: '2px'
              }}
            />
            <ErrorSpan>{errors.lastname}</ErrorSpan>
            <Input
              name="mail"
              type="email"
              error={errors ? errors.email : ''}
              value={email}
              onChange={event => setEmail(event.target.value)}
              className="form-control"
              aria-describedby="emailHelp"
              placeholder="E-mail"
              style={{
                border: errors.email ? '2px solid #c9444d' : '1px solid #ced4da', marginBottom: '2px'
              }}
            />
            <ErrorSpan>{errors.email}</ErrorSpan>
            <Input
              name="document"
              placeholder="CPF (Somente números)"
              error={errors ? errors.document : ''}
              value={document}
              pattern="[0-9]+"
              maxLength={11}
              onChange={event => {
                const re = /^[0-9\b]+$/;
                if (event.target.value === '' || re.test(event.target.value))
                  setDocument(event.target.value)
              }}
              className="form-control"
              style={{
                border: errors.document ? '2px solid #c9444d' : '1px solid #ced4da', marginBottom: '2px'
              }}
            />
            <ErrorSpan>{errors.document}</ErrorSpan>
            <Input
              type="password"
              value={password}
              error={errors ? errors.password : ''}
              onChange={event => setPassword(event.target.value)}
              className="form-control"
              placeholder="Senha (no mínimo 6 caracteres)"
              style={{
                border: errors.password ? '2px solid #c9444d' : '1px solid #ced4da', marginBottom: '2px'
              }}
            />
            <ErrorSpan>{errors.password}</ErrorSpan>
            <Input
              type="password"
              value={passwordConfirmation}
              error={errors ? errors.passwordConfirmation : ''}
              onChange={event => setPasswordConfirmation(event.target.value)}
              className="form-control"
              placeholder="Confirmar senha"
              style={{
                border: errors.confirmPassword ? '2px solid #c9444d' : '1px solid #ced4da', marginBottom: '2px'
              }}
            />
            <ErrorSpan>{errors.confirmPassword}</ErrorSpan>
            <CustomCheckBox
              label={link}
              checked={terms}
              onChange={() => setTerms(!terms)}
            />
            <ErrorSpan>{errors.terms}</ErrorSpan>
          </RegisterForm>
          <CreditCardForm>
            <CardTitle>Dados da Compra</CardTitle>
            <CourseContainer>
              <div style={{ width: 100, height: 100, backgroundColor: "#296ba9", borderRadius: 5 }}><img alt="iconic-logo" className="img-fluid" src={courseIcon} /></div>
              <CourseTextContainer>
                <strong style={{ fontSize: 24 }}>{course.name}</strong>
                {promotionCode === REACT_APP_PROMOTIONCODE ?
                  < span style={{ fontSize: 18, fontWeight: 'normal' }}>{utils.formatBRL(decimal.sub(course.price, decimal.div(decimal.mul(course.price, REACT_APP_PROMOTIONDISCOUNT), 100)))}</span>
                  :
                  <span style={{ fontSize: 18, fontWeight: 'normal' }}>{utils.formatBRL(course.price)}</span>
                }

              </CourseTextContainer>
            </CourseContainer>
            <Input
              name="paymentName"
              placeholder="Nome"
              maxLength={70}
              error={errors ? errors.paymentName : ''}
              value={paymentName}
              onChange={event => setPaymentName(event.target.value)}
              className="form-control"
              style={{
                border: errors.paymentName ? '2px solid #c9444d' : '1px solid #ced4da', marginBottom: '2px'
              }}
            />
            <ErrorSpan>{errors.paymentName}</ErrorSpan>
            <Input
              name="paymentDocument"
              placeholder="CPF (Somente números)"
              error={errors ? errors.paymentDocument : ''}
              value={paymentDocument}
              pattern="[0-9]+"
              maxLength={11}
              onChange={event => {
                const re = /^[0-9\b]+$/;
                if (event.target.value === '' || re.test(event.target.value))
                  setPaymentDocument(event.target.value)
              }}
              className="form-control"
              style={{
                border: errors.paymentDocument ? '2px solid #c9444d' : '1px solid #ced4da', marginBottom: '2px'
              }}
            />
            <ErrorSpan>{errors.paymentDocument}</ErrorSpan>
            <Input
              name="promotionCode"
              placeholder="Código de Desconto"
              maxLength={10}
              error={errors ? errors.promotionCode : ''}
              value={promotionCode}
              onChange={event => setPromotionCode(event.target.value)}
              className="form-control"
              style={{
                border: errors.promotionCode ? '2px solid #c9444d' : '1px solid #ced4da', marginBottom: '2px'
              }}
            />
            <Input
              type="select"
              name="installments"
              placeholder="Parcelas"
              value={installments}
              onChange={event => setInstallments(event.target.value)}
              className="form-control"
              style={{ border: errors.installments ? '2px solid #c9444d' : '1px solid #ced4da', marginBottom: '2px' }}>
              {priceWithInstallments.map((price, index) => {
              let text = `${settedInstallments[index]}x de ${utils.formatBRL(price)}` 
              if(settedInstallments[index] === 1) text += ` (Crédito à vista)`
              // else{
              //   text += ` (Recorrência)`
              // }
              return <option key={`price_${index}`} value={settedInstallments[index]}>{text}</option>
              })}
            </Input>
            <ErrorSpan>{errors.installments}</ErrorSpan>
            <PaymentInputsWrapper {...wrapperProps}>
              <svg {...getCardImageProps({ images })} />
              <input {...getCardNumberProps({ onChange: (event) => setCardNumber(event.target.value) })} placeholder="Nº do Cartão de Crédito" value={cardNumber} />
              <input {...getExpiryDateProps({ onChange: (event) => setExpiryDate(event.target.value) })} placeholder="MM/AA" value={expiryDate} />
              <input {...getCVCProps({ onChange: (event) => setCVC(event.target.value) })} value={cvc} />
            </PaymentInputsWrapper>
          </CreditCardForm>
        </FormWrapper>
        <FooterCard>
          <StyledButtonLink to="/">Já possuo uma conta</StyledButtonLink>
          <StyledButton onClick={submitForm}>Cadastrar e Comprar</StyledButton>
        </FooterCard>
      </RegisterCard>
    </BlockUi>
  </Container >;
}

export default BuyCourse;
